export default __webpack_public_path__ + "static/imgannonce3-f6c91a12dfb2d33fbe36a75abf1c1ac5.jpg";